import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import i18n from "i18n-react";

import Toast from 'components/Toast';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from "config/settings.json";

export default class TrainingDials extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedAnswerString: "",
			selectedAnswer: [],
			rotation: [],
			toastContent: null,
			headerImage: "",
		};
	}

	componentDidMount() {
		this.init();
		this.setHeader();
	}

	componentDidUpdate(prevProps) {
		const { quizMode, quizTimerExpired, error } = this.props;
		if (quizMode && quizTimerExpired && !prevProps.quizTimerExpired) {
			setTimeout(() => error(true), 600);
		}
	}

	async setHeader() {
		// Load profile image image
		const appInfo = await StorageHandler.load(storageKeys.appInfo);
		const { questionHeader } = appInfo;
		this.setState({ headerImage: questionHeader });
	}

	init() {
		const { rotation, selectedAnswer } = this.state;
		const { amountOfDials } = this.props;
		let selectedAnswerString = amountOfDials === 3 ? "" : "0";
		for (let i = 0; i < amountOfDials; i += 1) {
			rotation.push(0);
			selectedAnswer.push(0);
			selectedAnswerString += 0;
		}
		this.setState({ rotation, selectedAnswer, selectedAnswerString });
	}

	updateDial(e) {
		e.preventDefault();
		const { id, children } = e.target;
		const { rotation, selectedAnswer } = this.state;

		if (e.type === "click") {
			children[1].style.transform = `rotate(${(rotation[id] += 36)}deg)`;
			if (selectedAnswer[id] < 9) {
				selectedAnswer[id] += 1;
			} else {
				selectedAnswer[id] = 0;
			}
		}

		if (e.type === "contextmenu") {
			children[1].style.transform = `rotate(${(rotation[id] -= 36)}deg)`;
			if (selectedAnswer[id] > 0) {
				selectedAnswer[id] -= 1;
			} else {
				selectedAnswer[id] = 9;
			}
		}

		let selectedAnswerString = "";
		selectedAnswer.forEach((answer) => {
			selectedAnswerString += answer;
		});
		if (selectedAnswerString.length === 2) {
			selectedAnswerString = `0${selectedAnswerString}`;
		}

		this.setState({ rotation, selectedAnswer, selectedAnswerString });
	}

	checkAnswers() {
		const { selectedAnswerString } = this.state;
		const {
			correctAnswer,
			contentComplete,
			correctAnswerText,
			error,
			amountOfDials,
		} = this.props;

		let isCorrect = false;
		if (
			amountOfDials === 3 &&
			selectedAnswerString === correctAnswer.toString()
		) {
			isCorrect = true;
		} else if (
			amountOfDials === 2 &&
			selectedAnswerString.slice(-2) === correctAnswer.slice(-2)
		) {
			isCorrect = true;
		} else if (
			amountOfDials === 1 &&
			selectedAnswerString.slice(-1) === correctAnswer.toString().slice(-1)
		) {
			isCorrect = true;
		}

		if (isCorrect) {
			this.setState({
				toastContent: {
					content: correctAnswerText,
					position: "top-center",
				},
			});
			contentComplete();
		} else {
			// this.setState({
			//   toastContent: {
			//     type: 'error',
			//     content: incorrectAnswerText,
			//     position: 'top-center',
			//   },
			// });
			error(true);
		}
	}

	renderDials(amount) {
		const dials = [];
		const { correctAnswer, completedBefore } = this.props;
		for (let i = 0; i < parseInt(amount, 10); i += 1) {
			const key = i;
			const amt = parseInt(amount, 10);
			const digitsStr = (correctAnswer || "").toString();
			const lastDigits = digitsStr.slice(-amt);
			const prefillDigit = Number.parseInt(lastDigits[i] || "0", 10);
			dials.push(
				<Dial
					number={
						completedBefore ? prefillDigit : this.state.selectedAnswer[key] || 0
					}
					onClick={(e) => {
						this.updateDial(e);
					}}
					id={key}
					key={key}
				/>
			);
		}
		return dials;
	}

	render() {
		const {
			amountOfDials,
			question,
			disableHeader,
			error,
			disableToast,
			completedBefore,
			quizMode,
		} = this.props;

		const { toastContent, headerImage } = this.state;

		return (
			<div
				className={clsx('container__question', { 'quiz-mode-card': quizMode })}
				style={{
					pointerEvents: completedBefore ? "none" : "auto",
				}}
			>
				{!disableHeader && (
					<div
						className="container__question--image"
						style={{ backgroundImage: `url(${headerImage})` }}
					/>
				)}
				<div className="container__question--content">
					<h4 className="container__title">{question}</h4>
					<div className="dials__wrapper">
						{this.renderDials(amountOfDials)}
					</div>
					{!disableToast && (
						<Toast
							trigger={toastContent !== null}
							onOpen={() => {
								this.setState({ toastContent: null });
							}}
							{...toastContent}
						/>
					)}
					{!completedBefore && (
						<button
							onClick={() => {
								this.checkAnswers();
							}}
						>
							{i18n.translate("trainingScreens.confirm")}
						</button>
					)}
				</div>
				{error(false)}
				{this.props.correct(false)}
			</div>
		);
	}
}

const Dial = (props) => (
	<div
		className="dial"
		id={props.id}
		tabIndex={-1}
		role="button"
		onClick={(e) => {
			props.onClick(e);
		}}
		onKeyPress={(e) => {
			props.onClick(e);
		}}
		onContextMenu={(e) => {
			props.onClick(e);
		}}
	>
		<div className="number" id={`number_${props.id}`}>
			{props.number}
		</div>
		<img
			className="dial__image"
			src="https://front.travpromobile.com/main/dial_question.png"
			alt="dial"
		/>
	</div>
);


TrainingDials.propTypes = {
	amountOfDials: PropTypes.number.isRequired,
	contentComplete: PropTypes.func.isRequired,
	correct: PropTypes.func,
	correctAnswer: PropTypes.string.isRequired,
	correctAnswerText: PropTypes.string,
	disableHeader: PropTypes.bool,
	error: PropTypes.func,
	incorrectAnswerText: PropTypes.string,
	question: PropTypes.string.isRequired,
	disableToast: PropTypes.bool,
	completedBefore: PropTypes.bool,
	quizMode: PropTypes.bool,
	quizTimerExpired: PropTypes.bool,
};

TrainingDials.defaultProps = {
	correct: () => undefined,
	correctAnswerText: "",
	disableHeader: false,
	error: () => undefined,
	incorrectAnswerText: "",
	disableToast: false,
	completedBefore: false,
	quizMode: false,
	quizTimerExpired: false,
};

Dial.propTypes = {
	id: PropTypes.number.isRequired,
	number: PropTypes.number.isRequired,
	onClick: PropTypes.func.isRequired,
};
